import axios from "axios";
import { useState } from "react";
import { forceOnlyNumberInput } from "../../utils/function.utils";
import OTPInput from "react-otp-input";
const LoginPage = () => {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [token, setToken] = useState("");
  const [display, setDisplay] = useState(true);
  const [inputType, setInputType] = useState("password");

  function inputPhoneHandler(event) {
    let updatedValue = event.target.value;
    if (
      Number.isNaN(+event.target.value) === false &&
      updatedValue.length === 11
    ) {
      let inputData = {};
      inputData.mobile = updatedValue;
      axios.post(`/get-otp`, inputData).then((res) => {
        setToken(res.data.data.login_token);
        setDisplay(false);
      });
      setPhone(event.target.value);
    } else {
      setPhone(event.target.value);
    }
  }

  function firstRegister(event) {
    if (event._reactName === "onClick" || event.code === "Enter") {
      let inputData = {};
      inputData.mobile = phone;
      axios.post(`/get-otp`, inputData).then((res) => {
        setToken(res.data.data.login_token);
        setDisplay(false);
      });
    }
  }

  function secondRregister(event) {
    if (event._reactName === "onClick" || event.code === "Enter") {
      let inputData = {};
      inputData.mobile = phone;
      inputData.otp = password;
      axios.post(`/check-otp`, inputData).then((res) => {
        // localStorage.setItem("Authorization", res.data.token);
        if (res.status === 200) {
          let now = new Date();
          let time = now.getTime();
          let expireTime = time + res.data.expires_at;
          console.log(expireTime);
          now.setTime(expireTime);
          console.log(now.toUTCString());
          if (res.data.token !== undefined) {
            document.cookie = `Authorization=${
              res.data.token
            };expires=${now.toUTCString()};path=/`;
            window.location.href = "/";
          }
        }
      });
    }
  }

  return (
    <>
      <div className="bg-slate-200 w-full z-[100000000] h-[1000px] fixed top-0">
        {display && (
          <div className="h-fit max-w-[500px] bg-white m-auto mt-[200px] rounded-3xl px-10 py-4 flex flex-col items-center justify-center mx-[16px] 560:mx-auto ">
            <div className="flex flex-col 560:flex-row gap-y-[16px] justify-between my-[24px] items-start 560:items-center w-full">
              <label className="text-[16px] ">شماره تلفن:</label>
              <input
                type="text"
                className="border border-gray-300 rounded-md w-full 560:w-[300px] px-1 h-[32px]"
                value={phone}
                onChange={inputPhoneHandler}
              />
            </div>
            <div className="w-full flex justify-around mt-4">
              <button
                className="w-[80px] text-white bg-lime-600 h-[30px] rounded-md "
                onClick={firstRegister}
              >
                ثبت
              </button>
            </div>
          </div>
        )}
        {!display && (
          <div className="h-fit max-w-[500px] bg-white  m-auto mt-[200px] rounded-3xl p-10 mx-[24px] 560:mx-auto">
            {/* <div className="flex flex-col 560:flex-row gap-y-[16px] justify-between my-[24px] items-start 560:items-center w-full">
                            <label className="text-[16px] ">شماره تلفن:</label>
                            <input
                                type="text"
                                className="border border-gray-300 rounded-md w-full 560:w-[300px] px-1"
                                value={phone}
                                onChange={inputPhoneHandler}
                            />
                        </div> */}
            <div className="flex flex-col 560:flex-row gap-y-[16px] justify-between my-[24px] items-start 560:items-center w-full">
              <label className="text-[16px] ">کد پیامک شده:</label>
              <div className="relative w-full 560:w-auto">
                {/* <input
                                    type={inputType}
                                    className="border border-gray-300 rounded-md w-full 560:w-[300px] px-1"
                                    value={password}
                                    onChange={inputPasswordHandler}
                                    onKeyDown={secondRregister}
                                /> */}
                <OTPInput
                  value={password}
                  onChange={setPassword}
                  inputType={"number"}
                  shouldAutoFocus={true}
                  numInputs={4}
                  renderSeparator={false}
                  renderInput={(props) => <input {...props} />}
                  containerStyle={{
                    width: "284px",
                    height: "50px",
                    direction: "ltr",
                    gap: "24px",
                  }}
                  inputStyle={`flex-1 h-full bg-[#00000000] outline-none border border-[#B0B0B0] text-[#3C3C3C] text-14 font-medium rounded-[4px]`}
                />
                {/* <i
                  className={`fa ${
                    inputType === "password" ? "fa-eye" : "fa-eye-slash"
                  } absolute left-2 top-1 cursor-pointer`}
                  aria-hidden="true"
                  onClick={() => {
                    setInputType(
                      inputType === "password" ? "text" : "password"
                    );
                  }}
                ></i> */}
              </div>
            </div>
            <div className="w-full flex justify-around mt-12">
              <button
                className="w-[80px] text-white bg-lime-600 h-[30px] rounded-md "
                onClick={secondRregister}
              >
                ثبت
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default LoginPage;
